/**
 * A place for Popover things
 */
namespace appn.popover {

    export const HINT_TEMPLATE: string = appn.popover.HINT_TEMPLATE;
    const POPOVER_TEMPLATE: string = '<div class="popover" role="tooltip"><div class="arrow"></div><button type="button" class="x close" data-dismiss="popover"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button><div class="popover-body"></div></div>';

    export function init() {
        $('[data-widget="popover"]').popover({
            container: 'body',
            template: POPOVER_TEMPLATE
        });

        addEvents();
    }

    function addEvents() {
        $('[data-widget="popover"]').off().on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            const $this = $(this);
            $('[data-widget="popover"]').not(this).popover('hide');
            $this.popover('toggle');
        });

        $('[data-dismiss="popover"]').off().on('click', function(e) {
            e.preventDefault();
            $(this).closest('.popover').popover('hide');
        });

        $('html').off().on('click', function(e) {
            const popover = $('.popover.show');
            if (!popover.is(e.target) && popover.has(e.target).length === 0)
                appn.popover.dismissAll();
        });
    }

    /**
     * Dismisses any open popovers
     * @param e
     */
    export function dismissAll() {
        $('[data-widget="popover"]').popover('hide');
    }

    /**
     * Returns a hint label
     */
    export function hint(labelText: string, hintText: string, labelClasses?: string, placement?: string): string {

        if (!hintText)
            return appn.emptyString;

        if (!labelClasses)
            labelClasses = appn.emptyString;

        if (!placement)
            placement = 'top';

        let hint = HINT_TEMPLATE.replace('%labelText%', labelText)
            .replace('%hintText%', hintText)
            .replace('%labelClasses%', labelClasses)
            .replace('%placement%', placement);

        if (!labelText)
            hint = hint.replace('&nbsp;&nbsp;', appn.emptyString);

        return hint;
    }
}
